import { TranslocoService } from '@jsverse/transloco';
import { CoreDataUpdateService } from '../data-transfer/services/core-data-update-api-service';
import { inject } from '@angular/core';

export class LanguageHandler {

    private translateService: TranslocoService;
    private coreDataUpdateService: CoreDataUpdateService = inject(CoreDataUpdateService);

    constructor(translateService: TranslocoService) {
        this.translateService = translateService
    }

    setLanguage(countryCode: string): void {
        const language: string = (countryCode === 'gb' ? 'en' : countryCode);
        localStorage.setItem('language', language);
        this.coreDataUpdateService.updateCoreData();
        window.location.reload();
    }

    getLanguageCodes() {
        return this.translateService.getAvailableLangs().map(countryCode => countryCode.toString() === 'en' ? 'gb' : countryCode.toString());
    }
}

